import { io } from "socket.io-client";
import { SOCKET_URL } from "../http-common";
import { createScopedSocket } from "./socketScope";

// The app's single shared socket.io connection (24082026 — see
// socketScope.js for the full rationale). Components MUST use
// getScopedSocket() and never call io() directly: the scoped wrapper is
// what makes their disconnect()/off() calls safe against each other on
// the shared connection.
let shared = null;

export function getSharedSocket() {
  if (!shared) {
    shared = io(SOCKET_URL, { path: "/indiapayu-socket-path" });
  }
  return shared;
}

export function getScopedSocket() {
  return createScopedSocket(getSharedSocket());
}
